import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ServicesProvider } from 'src/providers/services';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Http, Headers, RequestOptions } from '@angular/http';
import * as $ from 'jquery';
import { CommonService } from 'src/providers/common';
import { Observable } from 'rxjs';
import { resolve } from 'dns';
import { rejects } from 'assert';
import { AddCall } from './addvCall';
//import { ApplePay } from '@ionic-native/apple-pay/ngx';
import { AlertController } from '@ionic/angular';
//declare var  : any
@Injectable()
export class Payment {
    options: InAppBrowserOptions = {
        // location: 'yes',// For android
        // //   location : 'no' ,// For IOS
        // hidden: 'no', //Or  'yes'
        // zoom: 'yes',//Android only ,shows browser zoom controls
        // hideurlbar: 'yes',//Or 'no'

        // location: 'yes', //Or 'no'
        // hidden: 'no', //Or 'yes'
        // clearcache: 'yes',
        // clearsessioncache: 'yes',
        // zoom: 'yes', //Android only ,shows browser zoom controls
        // hardwareback: 'yes',
        // mediaPlaybackRequiresUserAction: 'no',
        // shouldPauseOnSuspend: 'no', //Android only
        closebuttoncaption: 'Close', //iOS only
        // disallowoverscroll: 'no', //iOS only
        // toolbar: 'yes', //iOS only
        // enableViewportScale: 'no', //iOS only
        // allowInlineMediaPlayback: 'no', //iOS only
        presentationstyle: 'fullscreen', //iOS only
        // fullscreen: 'yes', //Windows only
        // hideurlbar: 'yes',//Or 'no'

        location: 'no', // Set to 'no' to hide the address bar
        toolbar: 'yes', // Set to 'no' to hide the toolbar
        fullscreen: 'yes',
        zoom: 'no',
        enableViewportScale: 'no'
    };
    private kneturl = "https://knettest.theonemoment.com/SendPerformREQuest.php?";
    private ids = localStorage.getItem("walkinId")
    private paymentsuccessurl = window.location.origin + "/knet";
    private getsessionURL = "https://ap-gateway.mastercard.com/api/rest/version/73/merchant/TESTMPGS_TEST/session";
    private payment_API_URL = "https://apitest.myfatoorah.com/v2/SendPayment";
    private payment_TOKEN = "rqsy0JGNbfqxbPduBB-80lgooTdEQ6D_vgsD_kaj5WC91RUuIbVOu5dzb6cnBU8SQmWDES88iz4bos-5dzmBODieUNjNdbUx3FsV2Oau-B_InrCH9qYvyoZber0L38fxyqnGOBnMOmWGBmkiiqwsbTRzPT3GhZDye58I1UUMntBAb_CLGk5iwhFUD6Y9aJTgi5QtwUlOEA89Cju8zJ2pkT8tpJTeqSVBcceM3hsiYbeOBFH9G2W7sUx7hX8QgR5-Azo-YAohZHh9Q3y0bqRdz2v_52JrQk1wnEINl-4ohcIdmzMmIiD5HoCUQdnX61WNVKMO4Q7njZOfx2RN9zbF_jHFuduJBgnS6mLyMGlOBNEzJMVl73LEg4qQBwOy3c43DGyRvZKQ-1WUmb55XGy4wlsG_lCoVOAgaQDkvRqXHT3NLcccgL9nAr0ZLvMHLMPNe6TPzwzd-5udM4ia5RtdtMTDphrhO4OM4LUxCMntnvSRFBGI5MLRToWbaadkO65DVjNI98beCEzVohTUilzZHNgHo5pEMTdNHT4PMg2vw0k1NcQ7NYfbkjoJYkNgZI5Q2MhWsyxUXjD769Am0kNgD3_bUBuqJ3vjJajIJUqCTC_hTdyCsce-GDEQ7RIUyyeB_TNbDFPquOWVeYcuK5huPzvM1a5RjKZy_vTgbKe6R-wl-LZiNKKtrYK9d12O5rSh2PUQaQ";
    constructor(private iab: InAppBrowser, private service: ServicesProvider, private http2: HTTP, private http: Http, private common: CommonService, public addCall: AddCall, public alertController: AlertController) { }



    generatePaymentOrderNo() {
        var first_segment = "tom";
        var second_segment = (Math.random() + 1).toString(36).substring(2);
        return first_segment + second_segment;
    }

    generatePaymentOrder_ID() {
        var second_segment = (Math.random() + 1).toString(36).substring(2);
        return second_segment;
    }

    generateKnetPaymentOrderNo() {
      var first_segment = (Math.random() + 1).toString(36).substring(2);
      var second_segment = (Math.random() + 1).toString(36).substring(2);
      return first_segment + second_segment;
  }

    async presentAlert(message) {
        const alert = await this.alertController.create({
            header: 'Alert',
            subHeader: 'Ionic 4 Apple Pay',
            message: message,
            buttons: ['OK']
        });

        await alert.present();
    }


    intpayment(Name, Email, Phoneno, Amount) {

        return new Promise((resolve, rejects) => {

            let paymentapidata = JSON.stringify({
                "vendor_name": Name,
                "phone": Phoneno,
                "vendor_email": Email,
                "amount": Amount,
                "callback_url": "http://65.1.90.247:3040/paymentsuccess?ad_id=48&success=true",
                // "webhook_url": "https://postapp.knpay.net/disclose_ok/",
            })

            this.service.paymentpostRequest('createPaymentRequest', paymentapidata).subscribe(response => {
                console.log(response, 'otto payment response');
                if (response.status == 1) {
                    console.log(response.Data);
                    let target = "_self";
                    $("#tabbar").hide();
                    // changeed the url instand of rediract url to checkout url
                    const browser = this.iab.create(response.data.checkout_url, target, this.options);
                    browser.on('loadstart').subscribe(event => {
                        console.log(event, 'eve');
                        let resurl = String(event.url)
                        if (resurl.includes("success")) {
                            console.log("Payment success");
                            let index = resurl.indexOf("?");
                            // const urlParams = new URLSearchParams(resurl.substr(index));
                            // console.log(urlParams);
                            // console.log(urlParams.get('paymentId'));
                            let orderandref = resurl.substr(index + 1);
                            let refno = orderandref.split('&')[0].split('=')[1];
                            let orderno = orderandref.split('&')[1].split('=')[1];

                            browser.close();
                            $("#tabbar").show();
                            resolve({ status: "1", payment_id: orderno, refnumber: refno });
                            // var respo = { status: "1", payment_id: urlParams.get('paymentId') }
                            // return respo
                        }
                        else if (resurl.includes("https://theonemoment-payment-failure.com")) {
                            console.log("Payment failed");
                            browser.close();
                            $("#tabbar").show();
                            resolve({ status: "0", payment_id: "0" });
                        }
                    });

                    browser.on('exit').subscribe(event => {
                        console.log("Exit", event);

                        $("#tabbar").show();
                        resolve({ status: "0", payment_id: "0" });
                    })
                } else {
                    //browser.close();
                    console.log("Payment Error");
                    $("#tabbar").show();
                    resolve({ status: "0", payment_id: "0" });
                }
            })
        })
    }


    initiatePayment2(Name, Email, Phoneno, Amount) {
        console.log('check payment', Amount);


        let order_no = "tom" + (Math.random() + 1).toString(36).substring(2)

        return new Promise((resolve, reject) => {
            try {

                let token = 'Api-Key ' + this.payment_TOKEN;

                this.http2.post(this.payment_API_URL, {

                    "amount": Amount,
                    "type": "e_commerce",
                    "currency_code": "KWD",
                    "pg_codes": ["knet-test"],
                    "customer_email": Email,
                    "full_name": Name,
                    "customer_phone": Phoneno,
                    "webhook_url": "https://postapp.knpay.net/disclose_ok/",
                    "redirect_url": "https://theonemoment-payment-success.com",
                    "order_no": order_no

                }, {
                    Authorization: token
                }).then(res => {
                    console.log(res);

                    let response = JSON.parse(res.data);
                    if (response.state == "created") {
                        console.log(response.Data);
                        let target = "_self";
                        $("#tabbar").hide();
                        const browser = this.iab.create(response.checkout_url, target, this.options);
                        browser.on('loadstart').subscribe(event => {
                            console.log(event);
                            let resurl = String(event.url)
                            if (resurl.includes("https://theonemoment-payment-success.com")) {
                                console.log("Payment success");
                                let index = resurl.indexOf("?");

                                const urlParams = new URLSearchParams(resurl.substr(index));
                                console.log(urlParams);
                                console.log(urlParams.get('paymentId'));

                                browser.close();
                                $("#tabbar").show();
                                resolve({ status: "1", payment_id: urlParams.get('paymentId') });
                                var respo = { status: "1", payment_id: urlParams.get('paymentId') }
                                return respo
                            }
                            else if (resurl.includes("https://theonemoment-payment-failure.com")) {
                                console.log("Payment failed");
                                browser.close();
                                $("#tabbar").show();
                                resolve({ status: "0", payment_id: "0" });
                            }
                        });

                        browser.on('exit').subscribe(event => {
                            console.log("Exit", event);

                            $("#tabbar").show();
                            resolve({ status: "0", payment_id: "0" });
                        })
                    } else {
                        //browser.close();
                        console.log("Payment Error");
                        $("#tabbar").show();
                        resolve({ status: "0", payment_id: "0" });
                    }
                    //
                    //this.loadinBrowser(response.Data.InvoiceURL);
                }, err => {
                    console.log("plug error");
                    console.log(err);
                    console.error(err);
                    $("#tabbar").show();
                    resolve({ status: "0", payment_id: "0" });
                });

            } catch (err) {
                console.log("Payment Exception");
                $("#tabbar").show();
                resolve({ status: "0", payment_id: "0" });
            }
        });
        // this.paymentAPI(reqData);
    }

    getsessionid(Name, Email, Phoneno, Amount) {
        return new Promise((resolve, reject) => {
            const order_on = this.generatePaymentOrderNo();
    
            const paymentapidata = JSON.stringify({
                "amount": Amount,
                "customer_email": Email,
                "full_name": Name,
                "customer_phone": Phoneno,
                "OrderId": order_on
            });
    
            this.service.paymentpostRequest('createSessionId', paymentapidata).subscribe(response => {
                if (response.status === 1) {
                    console.log(response.data);
    
                    const url = 'https://pay.theonemoment.com/';
                    const params = { param1: response.data.session.id };
                    const queryString = Object.keys(params)
                        .map(key => key + '=' + encodeURIComponent(params[key]))
                        .join('&');
    
                    const fullUrl = `${url}?${queryString}`;
                
                    const paymentWindow = window.open(fullUrl, "_self");
                    
                    const intervalId = setInterval(() => {
                        try {
                            if (paymentWindow.closed) {
                                clearInterval(intervalId);
                                $("#tabbar").show();
                                resolve({ status: "0", payment_id: "0" });
                            } else {
                                const resurl = paymentWindow.location.href;
                                
                                if (resurl.includes("https://theonemoment-payment-success.com")) {
                                    console.log(resurl, "result url");
                                    
                                    const resultindicator = new URL(resurl).searchParams.get('result');
                                    const sessionid = new URL(resurl).searchParams.get('session');
                                    
                                    console.log(resultindicator, 'resultindicator');
                                    console.log(sessionid, 'session');
                                    
                                    paymentWindow.close();
                                    $("#tabbar").show();
    
                                    resolve({
                                        status: "1",
                                        resultid: resultindicator,
                                        sessionid: sessionid,
                                        orderId: order_on,
                                        paymentGatewayName: "MASTER CARD"
                                    });
    
                                } else if (resurl.includes("https://theonemoment-payment-failure.com") || resurl.includes("https://theonemoment-payment-cancel.com")) {
                                    paymentWindow.close();
                                    $("#tabbar").show();
                                    resolve({ status: "0", payment_id: '' });
                                }
                            }
                        } catch (error) {
                            
                        }
                    }, 500); 
    
                } else {
                    resolve({ status: "0", sessionid: "0" });
                }
            });
        });
    }
    

    parseUrlParams(url: string): Record<string, string> {
        const params = new URLSearchParams(url);
        const result: Record<string, string> = {};

        params.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }

    checkCapture(result: string): boolean {
        return result === 'CAPTURED';
    }

    getpaymentid(url) {
        // Given string
        const responecurl = url;

        // Extracting paymentid value
        const paymentIdMatch = responecurl.match(/paymentid=(\d+)/);

        // Creating an object with paymentid
        const resultObject: Record<string, string> = {};

        if (paymentIdMatch) {
            const payment_id = resultObject['paymentid'] = paymentIdMatch[1];
            console.log("resultObject", resultObject['paymentid'] = paymentIdMatch[1]);
            return payment_id
        } else {
            return ""
        }
    }

    getKnetsessionid(Name: any, Email: any, Phoneno: any, Amount: any) {
        return new Promise((resolve, reject) => {
            const order_on = this.generatePaymentOrderNo();
            const generateTrackid = this.generateKnetPaymentOrderNo();
            let url = this.kneturl +
                "price=" +
                Amount +
                "&name=" +
                Name +
                "&email=" +
                Email +
                "&phone=" +
                Phoneno +
                "&return_url=" +
                this.paymentsuccessurl;
            var paymentWindow = window.open(url, '_self');
            window.addEventListener("message", async (event) => {
                if (event.origin === "https://knet.theonemoment.com" || event.origin === "https://knettest.theonemoment.com") {
                    const { url: resurl } = event.data;
    
                    if (resurl.includes("result.php")) {
                        const params = this.parseUrlParams(resurl);
                        const payment_id = this.getpaymentid(resurl);
    
                        if (params['result']) {
                            const isCaptured = this.checkCapture(params['result']);
    
                            if (isCaptured) {
                                console.log('Result is CAPTURED');
                                const requestdata = JSON.stringify({
                                    "paymentid": payment_id,
                                    "result": params['result'],
                                    "auth": params['auth'],
                                    "avr": params['avr'],
                                    "ref": params['ref'],
                                    "tranid": params['tranid'],
                                    "postdate": params['postdate'],
                                    "trackid": params['trackid'],
                                    "udf1": params['udf1'],
                                    "udf2": params['udf2'],
                                    "udf3": params['udf3'],
                                    "udf4": params['udf4'],
                                    "udf5": params['udf5'],
                                    "amt": params['amt']
                                });
    
                                try {
                                    const response = await this.service.postRequest("knetPaymentTransactions", requestdata).toPromise();
    
                                    if (Email) {
                                        const emailData = JSON.stringify({
                                            "paymentid": payment_id,
                                            "dateTime": this.formatDate(new Date()),
                                            "transactionid": params['tranid'],
                                            "title": "Knet Payment Success Details",
                                            "username": Name,
                                            "email": Email,
                                            "amount": params['amt']
                                        });
                                        await this.service.postRequest2("knetPaymentSuccessDetailsMail", emailData).toPromise();
                                    }
    
                                    resolve({
                                        status: "1",
                                        resultid: payment_id,
                                        sessionid: params['tranid'],
                                        orderId: order_on,
                                        paymentGatewayName: "KNET",
                                        amount: params['amt'],
                                        result: this.addCall.title632
                                    });
                                } catch (error) {
                                    console.error(error);
                                    resolve({
                                        status: "0",
                                        resultid: payment_id,
                                        sessionid: params['tranid'],
                                        orderId: order_on,
                                        paymentGatewayName: "KNET",
                                        amount: params['amt'],
                                        result: this.addCall.title633
                                    });
                                }
                            } else {
                                resolve({
                                    status: "0",
                                    resultid: payment_id,
                                    sessionid: params['tranid'],
                                    orderId: order_on,
                                    paymentGatewayName: "KNET",
                                    amount: params['amt'],
                                    result: this.addCall.title633
                                });
                            }
                        }
                        paymentWindow.close();
                    } else if (resurl.includes("failure.php")) {
                        paymentWindow.close();
                        resolve({ status: "2", payment_id: '' });
                    } else if (resurl.includes("payment-cancel.com")) {
                        paymentWindow.close();
                        resolve({ status: "2", payment_id: '' });
                    }
                }
            });
    
            paymentWindow.onerror = (error) => {
                console.error("Error opening payment window:", error);
                resolve({ status: "2", payment_id: "0" });
            };
        });
    }

    formatDate(date: Date): string {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear().toString();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

    getbacktopaymentgateway(session) {

        new Promise((resolve, rejects) => {



            // const url = 'http://157.241.52.117:4200/';
            const url = 'https://pay.theonemoment.com/';
            const params = { param1: session };

            const queryString = Object.keys(params)
                .map(key => key + '=' + encodeURIComponent(params[key]))
                .join('&');

            const fullUrl = `${url}?${queryString}`;



            // let  url = 'https://ap-gateway.mastercard.com/checkout/api/pageState/' + session + '?checkoutVersion=1.0.0'
            let target = "_self";
            $("#tabbar").hide();
            const browser = this.iab.create(fullUrl, target, this.options);
            browser.on('loadstart').subscribe(event => {
                console.log(event, "event IAB", String(event.url), "payment url")
                let resurl = String(event.url)
                if (resurl.includes("https://theonemoment-payment-success.com")) {
                    console.log(resurl, "result url");

                    let resultindicator = resurl.split('?')[1].split('&')[0].split('=')[1];
                    let sessionid = resurl.split('?')[1].split('&')[1].split('=')[1]

                    console.log(resultindicator, 'resultindicator');
                    console.log(sessionid, 'session');



                    browser.close();
                    $("#tabbar").show();

                    console.log(resultindicator, 'resultindicator');
                    console.log(sessionid, 'session');
                    resolve({ status: "1", resultid: resultindicator, sessionid: sessionid });

                }
                else if (resurl.includes("https://theonemoment-payment-failure.com")) {
                    browser.close();
                    $("#tabbar").show();
                    resolve({ status: "1", payment_id: '' });
                }
                else if (resurl.includes("https://theonemoment-payment-cancel.com")) {
                    browser.close();
                    $("#tabbar").show();
                    resolve({ status: "1", payment_id: '' });
                }
            })

            browser.on('exit').subscribe(event => {
                console.log("Exit", event);

                $("#tabbar").show();
                resolve({ status: "0", payment_id: "0" });
            })

        })

    }

    // ============================Mastet Card Start===========================
    getInitiatePayment (Name, Email, Phoneno, Amount) {
        // return new Promise((resolve, reject) => {
            debugger;
        const order_on = this.generatePaymentOrderNo();
        var obj = {
          vendor_name: Name,
          phone: Phoneno,
          customer_email: Email == "" ? "admin@theonemoment.com" :Email,
          amount: Amount,
          OrderId: order_on,
        }
        this.service.paymentpostRequest('createSessionId', obj).subscribe(res => {
            debugger;
            localStorage.setItem("order_on", order_on)
            console.log(res);
            if (window.Checkout) {
                window.Checkout.configure({
                  session: {
                    id: res.data.session.id,
                  },
                });
                window.Checkout.showPaymentPage();
              } else {
                console.error("Checkout is not available on window");
              }
          });
      }

    // ============================Mastet Card End===========================

        // =================================Knet=============================

getKnetPayment (Name: any, Email: any, Phoneno: any, Amount: any) {
    debugger

    let order_on = this.generatePaymentOrderNo();;
    var obj = {
      vendor_name: Name,
      phone: Phoneno,
      customer_email: Email,
      amount: Amount,
      OrderId: order_on,
    }

    // let payloadstr = JSON.stringify(payload);
    localStorage.setItem("order_on", order_on)
    localStorage.setItem("payloaddata", JSON.stringify(obj));
    let url = this.kneturl +
      "price=" +
      Amount +
      "&name=" +
      Name +
      "&email=" +
      Email +
      "&phone=" +
      Phoneno +
      "&return_url=" +
      this.paymentsuccessurl;
    window.open(url, '_self');
  }
// =================================Knet=============================


}